var _circle, _path, _circle2, _circle3, _path2, _rect, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSupplements = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 60,
  fill: "#F6F9FC"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C0D8F0",
  d: "M73.666 33.5v53c-3.056-.98-9.167-4.53-9.167-10.886V43.83c.064-2.41 1.986-7.85 9.167-10.33Z"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 43.499,
  cy: 45.833,
  r: 12.5,
  stroke: "#36485C",
  strokeWidth: 1.667
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 43.499,
  cy: 74,
  r: 12.5,
  stroke: "#36485C",
  strokeWidth: 1.667
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeWidth: 1.667,
  d: "m34.586 36.742 18 17.833M34.586 64.908l18 17.833M65.166 59.167h23.333"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24.667,
  height: 53.167,
  x: 64.499,
  y: 33.333,
  stroke: "#36485C",
  strokeWidth: 1.667,
  rx: 12.333
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeWidth: 1.667,
  d: "M77.499 39.674c2.114-.117 6.235 1.051 5.802 6.659"
})));
export default SvgSupplements;